package kz.dentalcrm.app.core.ui

import kotlinx.serialization.Serializable
import kz.dentalcrm.app.core.base.ViewState

data class UiError(
    val title: String? = null,
    val message: String? = null
)

sealed interface ScreenState : ViewState {

    data object Paginating : ScreenState

    data object Loading : ScreenState

    data object Idle : ScreenState
}

@Serializable
data class InputValue(
    val value: String = "",
    val error: String = ""
)